export function initHeroImages(): void {
    document.querySelectorAll<HTMLImageElement>('[data-hero-img]').forEach(img => {
        const show = () => img.setAttribute('data-loaded', '');
        if (img.complete) {
            show();
        } else {
            img.addEventListener('load', show);
        }
    });
}
